import React from 'react'
import { Redirect } from 'react-router-dom'
import { Skeleton } from 'antd'
import { useVerticalAccess } from 'hooks/useVerticalAccess'

interface VerticalAccessGuardProps {
  children: React.ReactNode
}

/**
 * @description
 * Route-level access guard for vertical pages.
 *
 * This component ONLY checks if a vertical is enabled (via isEnabled flag).
 * Behavior:
 * - If vertical is disabled → Redirect to /dashboard
 * - If vertical is enabled but no zone indices → Page responsibility what to show
 *
 * This separation ensures a proper UX for different data availability scenarios.
 */
export const VerticalAccessGuard: React.FC<VerticalAccessGuardProps> = ({ children }) => {
  const { isCurrentPathEnabled, isLoading } = useVerticalAccess()

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 10 }} />
  }

  if (!isCurrentPathEnabled) {
    return <Redirect to='/dashboard' />
  }

  return <>{children}</>
}
